import type { RouteRule } from '@components/router/async-router';

export const routes: RouteRule[] = [
  [() => import('./interview'), 'interview'],
  [() => import('./interview/preview'), 'interview/preview'],
  [() => import('./cal-public-event-types'), 'meet/:urlPrefix', 'meet-direct/:hostId'],
  [() => import('./cal-public'), 'meet/:urlPrefix/:urlSuffix', 'meet-direct/:hostId/:eventTypeId'],
  [() => import('./cal-public-scheduled'), 'calendar/bookings/:eventId'],
  [() => import('./cal-public-form'), 'calendar/form/:eventId'],
  [() => import('./cal-bookings-list'), 'calendar', 'calendar/bookings'],
  [() => import('./cal-availability-list'), 'calendar/availability', 'calendar/overrides'],
  [() => import('./cal-availability-edit'), 'calendar/availability/:id'],
  [
    () => import('./cal-edit-event-types'),
    'calendar/event-types/:id',
    'calendar/event-types/:id/:tab',
  ],
  [() => import('./cal-event-types-list'), 'calendar/event-types'],
  [() => import('./cal-overrides-edit'), 'calendar/overrides/:id'],
  [
    () => import('./cal-integrations'),
    'calendar/integrations',
    'calendar/integrations/:integrationType',
  ],
  [() => import('./cal-settings'), 'calendar/settings'],
  [() => import('./cal-domains'), 'calendar/domains'],
  [() => import('./cal-not-found'), 'calendar/*', 'meet/*'],
  [() => import('./cal-google'), 'calendar/oauth-google'],
  [() => import('./cal-onboarding'), 'calendar/onboarding'],
  [() => import('./cal-login'), 'calendar/login'],
  [() => import('./cal-forgot-password'), 'calendar/forgot-password'],
  [() => import('./cal-signup'), 'calendar/signup'],
  [() => import('./calendar-forms/index'), 'calendar/forms'],

  [() => import('./calendar-forms/cal-edit-form'), 'calendar/forms/:id', 'calendar/forms/:id/:tab'],

  [() => import('./page-builder'), 'calendar/page-builder', 'calendar/page-builder/:id'],
  [() => import('./landing-page'), 'calendar/landing-page/:hostId'],
];
